/*
    Renders default slot content with a wrapping element.
    Also supports wrapping and modification of default slot children 
*/

import { isTagEmpty, getComponentName } from '@/util/render';

export default {
    props: {
        wrapper: {
            type: [Object, String],
            default: 'div'
        },
        wrapperData: {
            type: Object,
            default:() => { }
        },

        // data that will be merged with each child's vNode properties
        childData: {
            type: Object,
            default: () => { }
        },
        childTagName: String
    },

    methods: {
        wrapChild(h, vNode) {
            if (!this.childTagName) return vNode;

            // if this node is already of the correct type, do not wrap it
            if (this.childTagName && this.childTagName === getComponentName(vNode)) {
                return Object.assign(vNode, this.childWrapperData);
            }

            return; 
        },
    },

    render(h) {
        /* 
            Remove tagless vNodes 
                <BaseRenderer>
                <div>I'm in a tag</div>
                I'm not in a tag!
                </BaseRenderer>
        */
        const childrenToRender = this.$slots.default.filter((vNode) => {
            return !isTagEmpty(vNode);
        }).map((vNode) => { 

            /* 
                Check to see if this vNode is of the correct type.
                If it is, apply childData directly to the vNode. If
                it is not, we will need to wrap the vNode in a new
                tag of type childTagName and apply childData to the wrapper
            */
            if (this.childTagName && this.childTagName === getComponentName(vNode)) { 
                return Object.assign(vNode, this.childData);
            }

            return h(this.childTagName, this.childData, [vNode]);
        });

        return h(this.wrapper, {
            attrs: this.$attrs
        }, childrenToRender);
    }
};
